<template>
  <div class="pa-10 pb-0">
    <p class="font-16">
      Sorry, quotes provided by {{ selectedQuote?.InsurerName }} were only valid
      until {{ formattedExpiryDate }}. Please go back to the quote results
      screen to choose a different insurer.
    </p>
    <div class="d-flex flex-column align-center mt-10">
      <BaseButton
        text="BACK TO QUOTE RESULTS"
        rounded
        depressed
        ripple
        color="mustard"
        width="100%"
        max-width="420"
        height="60"
        class="mx-auto font-weight-bold px-10 font-20 mb-4"
        @click="btnOk"
      />
    </div>
  </div>
</template>

<script>
import { getRouteObject } from "@/common/navigating";
import BaseButton from "@/components/BaseComponents/BaseButton";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DialogContentQuoteExpired",
  components: {
    BaseButton,
  },
  props: {
    selectedQuote: {
      type: Object,
      required: true,
    },
    section: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isQuestionSteps"]),
    formattedExpiryDate() {
      return moment(this.selectedQuote.QuoteExpiryDate).format("Do MMMM");
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["setRefreshQuote"]),
    btnOk() {
      this.setRefreshQuote(true);
      if (!this.isQuestionSteps) {
        const stub = getRouteObject();
        this.$router.push({
          name: stub.QUOTATION_RESULT,
        });
      }
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
